import { useCallback, useState } from 'react'
import { getFromLocalStorage, saveToLocalStorage } from '../../utils/browserStorageService'
import { ONE_WEEK_MS } from './date'

const checkOnce = value => Boolean(!value)

export const checkEachWeek = value => Date.now() - parseInt(value ?? '0', 10) > ONE_WEEK_MS

const useNotificationHelper = (key, checkFn = checkOnce) => {
  const state = checkFn(getFromLocalStorage(key))
  const [notificationActive, setNotificationActive] = useState(state)

  const disableNotification = useCallback(() => {
    setNotificationActive(false)
    saveToLocalStorage(key, Date.now())
  }, [])

  return { notificationActive, disableNotification }
}

export default useNotificationHelper
